import React from "react";
// import { ContentHeader, InfoCard, Progress } from "@backstage/core-components";
// import { useApi } from "@backstage/core-plugin-api";
// import { honeybadgerApiRef } from "@internal/plugin-honeybadger-api";
// import { FaultCard } from "@internal/plugin-honeybadger";
// import React, { useEffect, useState } from "react";
// import { Spacer } from "../Spacer/Spacer";
import { ExternalLink } from "@internal/plugin-utilities";
import { SectionHeader } from "../TeamBreakdown/SectionHeader/SectionHeader";

export interface Props {}

export const FaultsSection: React.FC<Props> = (): JSX.Element => {
  return (
    <>
      <SectionHeader
        vendor="honeybadger"
        title="Click the link below to see the Reports dashboard"
      />
      <ExternalLink href="https://app.honeybadger.io/projects/43379/reports?environment=production" />
    </>
  );
};
